function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52234",
  "data-name": "Path 52234",
  d: "M24,24H0V0H24Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "deployment",
  d: "M19.587,8.785A2.019,2.019,0,0,0,17.6,10.454H13.674a2.878,2.878,0,0,0-.6-1.436l2.76-2.76a2.023,2.023,0,1,0-.492-.492l-2.76,2.76a2.879,2.879,0,0,0-1.436-.6V4a2.016,2.016,0,1,0-.7,0V7.929a2.879,2.879,0,0,0-1.46.614L6.256,5.768a2.022,2.022,0,1,0-.493.492L8.508,9.041a2.877,2.877,0,0,0-.579,1.412H4a2.018,2.018,0,1,0,0,.7H7.93a2.881,2.881,0,0,0,.6,1.435l-2.76,2.76a2.023,2.023,0,1,0,.492.492l2.76-2.76a2.878,2.878,0,0,0,1.437.6V17.6a2.017,2.017,0,1,0,.7,0V13.675a2.875,2.875,0,0,0,1.413-.58l2.782,2.744a2.024,2.024,0,1,0,.491-.493l-2.775-2.738a2.881,2.881,0,0,0,.613-1.459H17.6a2.016,2.016,0,1,0,1.984-2.366Z",
  transform: "translate(0.816 0.816)",
  fill: "#7e84a3"
});

function SvgDeployIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "deployIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployIcon);
export default __webpack_public_path__ + "static/media/deployIcon.b6ea7d93.svg";
export { ForwardRef as ReactComponent };